import {Component, OnDestroy, OnInit} from '@angular/core';
import {CellEditorComponentBase} from "@shared/components/cell-components/cell-component";
import {CellValue} from "@shared/models/paged-response-model";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {QueryProvider} from "@shared/queries/query-provider";
import {getQueryResponse} from "@shared/store/selectors/query.selector";
import {select, Store} from "@ngrx/store";
import {takeUntil} from "rxjs/operators";
import {IQueryState} from "@shared/store/reducers/query.reducer";
import {Subject} from "rxjs";

@Component({
    standalone: false,
    selector: 'particle-arrangement-chart-organization-name-cell-editor',
  templateUrl: './arrangement-chart-organization-name-cell-editor.component.html',
  styleUrls: ['./arrangement-chart-organization-name-cell-editor.component.scss']
})
export class ArrangementChartOrganizationNameCellEditorComponent extends CellEditorComponentBase implements OnInit, OnDestroy {
  countryList = [];
  form: FormGroup;
  inputForm: any;
  inputFormError: any;
  clientType: string;
  private ngUnsubscribe$ = new Subject<void>();
  releventTaxpayers = [];

  constructor(private formBuilder: FormBuilder,
              private queryStore: Store<IQueryState>) {
    super();
    this.inputFormError = {
      OrganisationName_6_p: {},
      ResidenceCountryCode_12_p: {}
    };
    this.inputForm = this.formBuilder.group({
      OrganisationName_6_p: ['', Validators.required],
      EntityCode: [''],
      ResidenceCountryCode_12_p: ['', Validators.required],
      Tin_12_p: [''],
      EmailAddress_6_p: ['']
    });
  }

  ngOnInit() {
    if(this.item.cells['ID'] && this.item.cells['ID'].value){
      this.clientType = this.item.cells['ID'].value;
    }
    this.inputForm.patchValue({
      OrganisationName_6_p: this.getFormFieldValue('OrganisationName_6_p'),
      EntityCode: this.getFormFieldValue('EntityCode'),
      ResidenceCountryCode_12_p: this.getFormFieldValue('ResidenceCountryCode_12_p'),
      Tin_12_p: this.getFormFieldValue('Tin_12_p'),
      EmailAddress_6_p: this.getFormFieldValue('EmailAddress_6_p')
    });
    this.inputForm.valueChanges.subscribe(() => {
      this.onFormValuesChanged();
    });
    this.queryStore.pipe(takeUntil(this.ngUnsubscribe$), select(getQueryResponse, 'Dac6-CountryCode-Config')).subscribe(response=>{
      if(response && response.items){
        this.countryList = response.items;
      }
    })
    this.queryStore.pipe(takeUntil(this.ngUnsubscribe$), select(getQueryResponse, 'AllRelevantTaxPayers')).subscribe(response=>{
      if(response && response.items){
        this.releventTaxpayers = response.items;
        this.inputForm.patchValue({
          OrganisationName_6_p: this.getFormFieldValue('OrganisationName_6_p'),
        });
      }
    });
    QueryProvider.invokeQuery(this.queryStore, 'Dac6-CountryCode-Config', {});
    QueryProvider.invokeQuery(this.queryStore, 'AllRelevantTaxPayers', {});
  }

  onFormValuesChanged(){
    for (const field in this.inputFormError) {
      if (!this.inputFormError.hasOwnProperty(field)) {
        continue;
      }
      this.inputFormError[field] = {};
      const control = this.inputForm.get(field);
      if (control && control.dirty && !control.valid) {
        this.inputFormError[field] = control.errors;
      }
    }
    this.validationChange.emit(this.inputForm.valid);
    this.item.cells = {
      ...this.item.cells,
      'Organisation': this.getPersonData()
    };
    this.valueChanged.emit({item: this.item, fieldDefinition: this.fieldDefinition});
  }
  private getFormFieldValue(fieldKey: string): string {
    if(this.item.cells[this.fieldDefinition.key] &&
      this.item.cells[this.fieldDefinition.key].value &&
      this.item.cells[this.fieldDefinition.key].value.fieldValues &&
      this.item.cells[this.fieldDefinition.key].value.fieldValues[fieldKey]){
      return this.item.cells[this.fieldDefinition.key].value.fieldValues[fieldKey];
    }
    return '';
  }
  private getPersonData() {
    if(this.item.cells[this.fieldDefinition.key]){
      return {
        ...this.item.cells[this.fieldDefinition.key],
        value: {
          fieldValues: this.inputForm.value
        }
      };
    }else{
      return {
        value: {
          fieldValues: this.inputForm.value
        }
      }
    }
  }
  onSelectRTP(event : any){
    const selectedRtp = this.releventTaxpayers.find(item=>item.entityName === event.value);
    if(selectedRtp.countryOfResidence){
      this.inputForm.patchValue({
          ResidenceCountryCode_12_p : selectedRtp.countryOfResidence
      })
    }
    if(selectedRtp.entityCode){
      this.inputForm.patchValue({
        EntityCode : selectedRtp.entityCode
      })
    }
  }
  ngOnDestroy(): void {
    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.complete();
  }
}
